/**
 * Simple and reliable production mode detection
 * Based on hostname rather than environment variables
 */

export function isProductionEnvironment(): boolean {
  if (typeof window === 'undefined') {
    return false; // Server-side rendering or Node.js
  }

  const hostname = window.location.hostname;
  return hostname === 'playbook.airclou.com' ||
         hostname.includes('airclou.com') ||
         (!hostname.includes('localhost') && !hostname.includes('127.0.0.1'));
}
